import script from "./PurchaseComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseComplete.vue?vue&type=script&setup=true&lang=js"

export default script